// extracted by mini-css-extract-plugin
export default {"shimmer":"_1f7544ed","shimmerLoadingBackground":"_b9b2df45","container":"_a4b5b1cf","image":"_dab8fdaf _1f7544ed","blockContainer":"_afb09ac6","block":"_db39a41 _1f7544ed"};